import { Action } from 'redux';
import { put } from '@redux-saga/core/effects';
import { CheckoutActions, CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { ErrorAction, AppState } from '../../root.types';
import { select, all } from 'redux-saga/effects';
import { loadBasketSaga } from 'store/basket/actions';
import { DeliveryDetailsModel, CustexCustomerDetailsModel, HybrisCustomerDetailsModel } from 'models';
import { api } from 'repositories/api';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';

export interface LoadDeliveryDetailsAction extends Action<CheckoutActionTypes.LOAD_DELIVERY_DETAILS> {
}

export interface LoadDeliveryDetailsActionStart extends Action<CheckoutActionTypes.LOAD_DELIVERY_DETAILS_START> {
}

export interface LoadDeliveryDetailsActionSuccess extends Action<CheckoutActionTypes.LOAD_DELIVERY_DETAILS_SUCCESS> {
    deliveryDetails: DeliveryDetailsModel;
}

export interface LoadDeliveryDetailsActionError extends ErrorAction<CheckoutActionTypes.LOAD_DELIVERY_DETAILS_ERROR> {
}

export const loadDeliveryDetails: () => LoadDeliveryDetailsAction = () => ({
    type: CheckoutActionTypes.LOAD_DELIVERY_DETAILS
});
loadDeliveryDetails[ACTION_CREATOR_NAME] = 'loadDeliveryDetails';

export type LoadDeliveryDetailsFunc = (...args: Parameters<typeof loadDeliveryDetails>) => void;

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* loadDeliveryDetailsSaga(): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.LOAD_DELIVERY_DETAILS_START
    });

    try {
        let state: AppState = yield select();

        if (!state.basketState.basket) {
            yield callBasketSaga(loadBasketSaga);
        }

        state = yield select();
        const basket = state.basketState.basket!;

        const userId = basket.session.userId;

        let deliveryDetails = new DeliveryDetailsModel();
        let [
            custexCustomerDetails,
            hybrisCustomerDetails
        ]: [CustexCustomerDetailsModel, HybrisCustomerDetailsModel] = yield all([
            api.custex.getCustomerDetails(userId),
            api.hybris.getCustomerDetails(userId)
        ]);

        deliveryDetails.firstName = custexCustomerDetails.firstName;
        deliveryDetails.surname = custexCustomerDetails.surname;
        deliveryDetails.phone = custexCustomerDetails.phoneNumbers.length > 0 ? custexCustomerDetails.phoneNumbers[0].number : '';
        deliveryDetails.allowEmailContacts = custexCustomerDetails.allowEmailContacts;
        deliveryDetails.allowPhoneContacts = custexCustomerDetails.allowPhoneContacts;

        deliveryDetails.deliveryAddress = hybrisCustomerDetails.deliveryAddress;
        deliveryDetails.billingAddress = hybrisCustomerDetails.billingAddress;

        // postcodes can be different if customer logged in on the checkout step
        if (deliveryDetails.deliveryAddress && !basket.deliveryAddress!.postcode.isEqual(deliveryDetails.deliveryAddress?.postcode)) {
            deliveryDetails.deliveryAddress = null;
        }

        if (hybrisCustomerDetails.isCustomerInfoExists) {
            deliveryDetails.title = hybrisCustomerDetails.title && hybrisCustomerDetails.title.length > 0 ? hybrisCustomerDetails.title : '';
            deliveryDetails.firstName = hybrisCustomerDetails.firstName && hybrisCustomerDetails.firstName.length > 0 ? hybrisCustomerDetails.firstName : '';
            deliveryDetails.surname = hybrisCustomerDetails.surname && hybrisCustomerDetails.surname.length > 0 ? hybrisCustomerDetails.surname : '';
            deliveryDetails.phone = hybrisCustomerDetails.phone && hybrisCustomerDetails.phone.length > 0 ? hybrisCustomerDetails.phone : '';
        }

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.LOAD_DELIVERY_DETAILS_SUCCESS,
            deliveryDetails
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.LOAD_DELIVERY_DETAILS_ERROR,
            error: errorToBasketErrorModel(error, 'loadDeliveryDetailsSaga')
        });

        return false;
    }
}
